import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react'

import cn from 'clsx'

import s from './styles.module.scss'

type CardType = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'title'> & {
  headerRightElement?: ReactNode
  title?: string | ReactNode
  contentClassName?: string
  titleContainerClassName?: string
  headerClassName?: string
}

export const Card = ({
  children,
  headerRightElement,
  title,
  contentClassName,
  titleContainerClassName,
  headerClassName,
  ...props
}: CardType) => {
  return (
    <div {...props} className={cn(s.container, props.className)}>
      <div className={cn(s.header, headerClassName)}>
        <div className={cn(s.title, titleContainerClassName)}>{title}</div>
        {headerRightElement}
      </div>
      <div className={cn(s.content, contentClassName)}>{children}</div>
    </div>
  )
}
